import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/AE403mid21.pdf'

export default function Ssm() {
  return (
    <div>
       <Subject title="Soil Science & Soil Mechanics(AE403)" book1=" " book2=" "mid="Q. Paper"
    book1Link="#" book2Link="#" int21="#" mid21={csm} end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}